import { getUserInfoFromCache } from "utility/helper";

const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:5072/api";

export type DownloadSupplierProductsZipParams = {
  productIds?: number[];
  mediaAssetIds?: number[];
  relationTypes?: string[];
};

function buildFallbackZipFileName(): string {
  const now = new Date();
  const date = now.toISOString().slice(0, 10);
  return `vb-pim-export-${date}-${now.getTime()}.zip`;
}

function getFileNameFromContentDisposition(header: string | null): string | null {
  if (!header) {
    return null;
  }
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }
  const plainMatch = /filename="?([^";]+)"?/i.exec(header);
  return plainMatch?.[1]?.trim() ?? null;
}

export async function downloadSupplierProductsZip(
  params: DownloadSupplierProductsZipParams,
): Promise<void> {
  const token = getUserInfoFromCache()?.token;
  if (!token) {
    throw new Error("Du är inte inloggad");
  }

  const productIds = params.productIds ?? [];
  const mediaAssetIds = params.mediaAssetIds ?? [];
  if (productIds.length === 0 && mediaAssetIds.length === 0) {
    throw new Error("Inga produkter eller filer valda");
  }

  const response = await fetch(`${API_URL}/files/download-zip`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      productIds,
      mediaAssetIds: mediaAssetIds.length > 0 ? mediaAssetIds : undefined,
      relationTypes: params.relationTypes,
    }),
  });

  if (!response.ok) {
    let message = "Kunde inte skapa ZIP-filen";
    try {
      const payload = await response.json();
      if (payload?.message || payload?.Message) {
        message = payload.message ?? payload.Message;
      }
    } catch {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const fileName =
    getFileNameFromContentDisposition(
      response.headers.get("content-disposition"),
    ) ?? buildFallbackZipFileName();

  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
}
